import { createApp } from '@/helpers/alpine';
import { AlpineComponents } from 'alpinejs';

import '@/services/lazyload';
import { CookieConsent } from '@/services/cookie-consent';
import { DynamicDatas } from '@/services/dynamic-datas';

import { AudioPlayer } from '@/components/audio-player';
import { CheckoutAction } from '@/components/checkout-action';
import { DaterangePicker } from '@/components/daterange-picker';
import { EmailCheck } from '@/components/email-check';
import { Elastic } from '@/components/elasticsearch';
import { Navigation } from '@/components/navigation';
import { Pagination } from '@/components/pagination';
import { PasswordStrength } from '@/components/password-strength';
import { ProductAttributes } from '@/components/product-attributes';
import { ProductOptions } from '@/components/product-options';
import { Range } from '@/components/range';
import { Sliders } from '@/components/sliders';
import { Spinner } from '@/components/spinner';
import { Toggler } from '@/components/toggler';
import { VideoPlayerYoutube } from '@/components/video-player-youtube';
import { VideoPlayerHtml } from '@/components/video-player-html';

import { productScrollbar } from '@/partials/product-scrollbar';

import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';
// import clipboard from "@/plugins/clipboard";
// import datalayer from "@/plugins/datalayer";
// import fitIframe from "@/plugins/fit-iframe";
// import obfuscatedLinks from '@/plugins/obfuscated-links';

import { CartActions } from '@/core/cart-actions';
import { Checkout } from '@/core/checkout';
import { CheckoutStep } from '@/core/checkout-step';
import { Product } from '@/core/product';

import ps_shoppingcart from '@/modules/ps_shoppingcart';

const Core: AlpineComponents = {
    // import ui core
    CartActions,
    Checkout,
    CheckoutStep,
    Product,
};

const Components: AlpineComponents = {
    // import ui components
    AudioPlayer,
    DaterangePicker,
    CheckoutAction,
    EmailCheck,
    Elastic,
    Navigation,
    Pagination,
    PasswordStrength,
    ProductAttributes,
    ProductOptions,
    Range,
    Sliders,
    Spinner,
    Toggler,
    VideoPlayerYoutube,
    VideoPlayerHtml,
};

const Partials: AlpineComponents = {
    // import ui partials
    productScrollbar,
};

const Modules: AlpineComponents = {
    ps_shoppingcart,
};

createApp(
    {
        Core,
        Components,
        Partials,
        Modules,
    },
    [
        // Plugins :
        collapse,
        intersect,
        // clipboard,
        // datalayer,
        // fitIframe,
        // obfuscatedLinks,
    ],
);

DynamicDatas();
CookieConsent();

// Available services startup
// DataLayer.init();
